import { render, staticRenderFns } from "./PutCursor.vue?vue&type=template&id=523d293e&scoped=true&"
import script from "./PutCursor.vue?vue&type=script&lang=js&"
export * from "./PutCursor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d293e",
  null
  
)

export default component.exports